var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDashboard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22248 4.60103C6.66506 4.3054 7.1317 4.04749 7.61748 3.83003C8.98948 3.21503 9.67548 2.90803 10.5875 3.50003C11.5005 4.09003 11.5005 5.06003 11.5005 7.00003V8.50003C11.5005 10.386 11.5005 11.328 12.0865 11.914C12.6725 12.5 13.6145 12.5 15.5005 12.5H17.0005C18.9405 12.5 19.9105 12.5 20.5005 13.412C21.0925 14.325 20.7855 15.011 20.1705 16.382C19.2914 18.3459 17.7716 19.9532 15.8599 20.9406C13.9481 21.928 11.7578 22.237 9.64748 21.817C7.80473 21.4505 6.11207 20.5457 4.78351 19.2172C3.45496 17.8886 2.55017 16.196 2.18358 14.3532C1.81698 12.5105 2.00502 10.6004 2.72394 8.86456C3.44285 7.12869 4.66035 5.64498 6.22248 4.60103Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.446 7.06883C21.0424 6.04737 20.4334 5.11963 19.6568 4.34301C18.8802 3.56639 17.9525 2.95743 16.931 2.55383C15.389 1.94683 14 3.34383 14 4.99983V8.99983C14 9.26504 14.1054 9.5194 14.2929 9.70693C14.4804 9.89447 14.7348 9.99983 15 9.99983H19C20.657 9.99983 22.053 8.60983 21.446 7.06883Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDashboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dashboard.6ce788419aad49826b96c94386ce35cd.svg";